import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import Editor from "../../components/Editing/Editor";
import TextField from "../../components/Editing/TextField";
import DropdownField from "../../components/Editing/DropdownField";
import { nameofFactory, hasWriteAccess } from "../../utils/utils";
import { getIoEnumOptions } from "../../utils/pdApiUtils";
import { EditActions, editActions } from "../../actions/editActions";
import BitMaskField from "../../components/Editing/BitMaskField";
import { DropdownOption } from "../../utils/pdApiUtils";

type StateProps = {
  editedEnumeration: Api.IodataSections;
  storedEnumeration: Api.IodataSections;
  pdApi: State.PdApi;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
  dataFieldName: keyof State.PdApi;
};

const baseEnumFields = nameofFactory<Api.IodataSections>();

export type EditIoDataSectionsProps = StateProps & DispatchProps & OwnProps;

export class EditIoDataSections extends React.Component<EditIoDataSectionsProps> {
  render(): JSX.Element {
    const {
      editedEnumeration,
      storedEnumeration,
      activeUser,
      toggleModal,
      dataFieldName
    } = this.props;
    const enumOptions = [
      { text: "", value: null } as DropdownOption,
      ...getIoEnumOptions(this.props.pdApi.enumerations)
    ];
    return (
      <Editor
        itemName={"Enumeration"}
        originalObject={storedEnumeration}
        editedObject={editedEnumeration}
        hasWritePermission={hasWriteAccess(activeUser, "Lift")}
        isValid={this.isAllFieldsValid()}
        cancel={this.props.editActions.cancelEditing}
        update={() => this.props.editActions.update(dataFieldName as Api.OptionsGrud)}
        create={() => this.props.editActions.add(dataFieldName as Api.OptionsGrud)}
        remove={{ callback: toggleModal }}
      >
        <TextField
          id="dataSectionName"
          label="Name"
          value={editedEnumeration ? editedEnumeration.name : ""}
          isError={editedEnumeration && !this.isFieldValid(baseEnumFields("name"))}
          errorMessage={!this.isEmptyString(editedEnumeration.name) ? "The name must be unique." : ""}
          onChange={name => this.props.editActions.setEdited({ ...editedEnumeration, name })}
        />
        <BitMaskField
          id="dataSectionMask"
          label="Bitmask"
          subLabel="Value Range"
          maskValue={editedEnumeration ? editedEnumeration.mask : ""}
          isError={editedEnumeration && !this.isFieldValid(baseEnumFields("mask"))}
          onMaskChange={(mask, offset) => {
            this.props.editActions.setEdited({ ...editedEnumeration, mask, offset });
            return mask;
          }}
        />
        <DropdownField
          id="dataSectionEnumeration"
          label="Bound Enumeration"
          value={
            editedEnumeration && editedEnumeration.enumeration
              ? editedEnumeration.enumeration.id
              : enumOptions[0].value
          }
          options={enumOptions}
          onChange={id => {
            const enumeration = _.find(this.props.pdApi.enumerations, item => item.id === id);
            this.props.editActions.setEdited({
              ...editedEnumeration,
              enumeration: enumeration
            });
          }}
        />
      </Editor>
    );
  }

  private isEmptyString = (str: string): boolean => !(!!str && str.length > 0);
  
  private isFieldValid = (field: string): boolean => {
    const { editedEnumeration, pdApi } = this.props;
    switch (field) {
      case baseEnumFields("name"): {
        const { name } = editedEnumeration;
        if (this.props.storedEnumeration) {
          return true;
        }
        if (!name || name.length === 0) {
          return false;
        } else {
          return _.values(pdApi[this.props.dataFieldName]).find(
            enumeration => enumeration.name === editedEnumeration.name
          )
            ? false
            : true;
        }
      }
      default:
        return true;
    }
  };

  private isAllFieldsValid = (): boolean => {
    const { editedEnumeration } = this.props;
    const temp = _.keys(editedEnumeration);
    for (const key of temp) {
      if (!this.isFieldValid(key)) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedEnumeration: state.editView.editedObject,
  storedEnumeration: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIoDataSections);


